<template>
  <div id="app" class="wrapper">
    <!-- <Push disableOutsideClick> -->
    <v-navigation-drawer
      temporary
      v-model="drawer"
      width="300"
      fixed
      color="rgb(240,240,240)"
      floating
    >
      <div class="d-flex flex-column align-center">
        <img src="@/assets/dn2me.svg" alt />
      </div>

      <ul>
        <li @click="goHome">
          <p :class="{actived: this.$route.name === 'home'}">Κεντρική σελίδα</p>
        </li>
        <!-- <li @click="$router.push('/terms').then().catch(err => {})">
          <p :class="{actived: this.$route.name === 'terms'}">Terms & Conditions</p>
        </li>
        
        <li>
          <p>About</p>
        </li>-->
        <li @click="goProfile">
          <p :class="{actived: this.$route.name === 'profile' ||  this.$route.name === 'editProfile'}">Προφίλ</p>
        </li>
        <li @click="goTerms">
          <p :class="{actived: this.$route.name === 'terms'}">Όροι & Προϋποθέσεις</p>
        </li>
        <li @click="goInfo">
          <p :class="{actived: this.$route.name === 'info'}">Σχετικά</p>
        </li>
        <li class="mt-12" @click="logout">
          <p>Αποσύνδεση</p>
        </li>

        <li style="position:absolute; bottom:0; ">
          <p style="font-size:13px; color:rgb(74,74,74)">Version: 1.0.0</p>
        </li>
      </ul>
    </v-navigation-drawer>

    <!-- </Push> -->

    <v-icon
      @click="drawer = true"
      x-large
      v-if="!($route.name ==='room')"
      :style="($route.name !== 'profile') ? 'position:fixed; top:10px; left:10px; cursor: pointer; background-color:WHITE; border-radius:50%; z-index:1;' : 'position:fixed; top:10px; left:10px; cursor: pointer; color:white; border-radius:50%; z-index:1;'"
    >mdi-menu</v-icon>

    <router-view></router-view>

    <v-dialog hide-overlay persistent v-model="dialog" width="400">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column pa-10 align-center">
            <h2>Ο χρήστης {{!!$store.state.object ? $store.state.object.travellerFirstName : ''}} {{!!$store.state.object ? $store.state.object.travellerLastName : ''}} σας καλεί από Δήμο {{!!$store.state.object ? $store.state.object.travellerMunicipality : ''}}</h2>

            <div class="d-flex align-center justify-center mt-10">
              <v-btn
                @click="accept"
                rounded
                width="100"
                height="40"
                depressed
                color="green"
                class="white--text text-capitalize"
              >
                <p class="mb-0">Απάντηση</p>
              </v-btn>
              <v-btn
                @click="decline"
                rounded
                width="100"
                height="40"
                depressed
                color="rgb(255,0,0)"
                class="white--text text-capitalize ml-2"
              >
                <p class="mb-0">Απόρριψη</p>
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="$store.state.permissionDenied===false"
      persistent
      v-model="ratingDialog"
      width="400"
    >
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center py-5 px-sm-2 px-md-10">
            <h2 class="text-center font-weight-bold black--text mb-2">Πώς σας φάνηκε αυτή η κλήση;</h2>
            <p
              class="text-center"
            >Τα σχόλια σας δεν θα κοινοποιηθούν στον ασθενή. Θα μας βοηθήσουν να περιορίσουμε τις περιττές κλήσεις και να να προσφέρουμε μια καλύτερη υπηρεσία.</p>

            <v-radio-group v-model="rating">
              <v-radio
                class="box"
                label="Ο ασθενής χρειαζόταν άμεση ιατρική υποστήριξη"
                color="rgb(0,170,221)"
                value="urgent"
              ></v-radio>

              <v-radio
                class="box"
                label="Ο ασθενής δεν είχε άμεσες/επείγουσες ανησυχίες σε σχέση με την υγεία του"
                color="rgb(0,170,221)"
                value="useful"
              ></v-radio>
              <v-radio
                class="box"
                label="Η κλήση δεν είχε σχέση με θέματα υγείας ή ήταν αναίτια"
                color="rgb(0,170,221)"
                value="useless"
              ></v-radio>

              <v-radio
                class="box"
                label="Δεν γνωρίζω, η κλήση διακόπηκε απότομα"
                color="rgb(0,170,221)"
                value="noRating"
              ></v-radio>
            </v-radio-group>

            <v-btn
              rounded
              depressed
              color="rgb(0,170,221)"
              class="white--text text-capitalize"
              @click="rate"
              :disabled="rating==null"
              :loading="loading"
            >
              <p class="mb-0">Υποβολή</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-overlay v-model="loggingOut"></v-overlay>
  </div>
</template>

<script>
const { connect, createLocalVideoTrack } = require("twilio-video");
const signalR = require("@microsoft/signalr");
import { Howl, Howler } from "howler";
import Axios from "axios";
import * as firebase from "firebase";
const DetectRTC = require("detectrtc");
import axios from "axios";
export default {
  data() {
    return {
      drawer: false,

      dialog: false,
      sound: this.$store.state.sound,

      rating: null,
      loading: false
    };
  },
  computed: {
    connection() {
      return this.$store.state.connection;
    },
    object() {
      return this.$store.state.object;
    },
    loggingOut() {
      return this.$store.state.loggingOut;
    },
    ratingDialog() {
      return this.$store.state.ratingDialog;
    }
  },
  created() {
    document.getElementById("app").focus();
    //  getAudioContext().resume()

    console.log(this.sound);

    //    this.sound=new Audio('sound.mp3')

    window.addEventListener("beforeunload", () => {
      this.room.disconnect();

      if (this.$store.state.object !== null) {
        this.$store.state.connection.invoke("endCall", this.object);
        this.$store.dispatch("setObject", null);
      }
    });

    const token = sessionStorage.getItem("token");
    if (!!token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/user/getNotifToken`)
        .then(res => {
          console.log("getFcm", res);
          if (res.data !== localStorage.getItem("fcmToken")) {
            console.log("not same");
            this.$store.state.user = null;
            sessionStorage.removeItem("user");

            this.$store.state.token = null;
            sessionStorage.removeItem("token");

            delete axios.defaults.headers.common["Authorization"];

            this.$router.replace("/login");
          } else {
            const localConnection = new signalR.HubConnectionBuilder()
              .withUrl(
                `https://cn2me-${
                  process.env.VUE_APP_environment
                }-backend.azurewebsites.net/notificationHub?token=${
                  this.$store.state.token
                }&operatingSystem=${DetectRTC.osName.toLowerCase()}&appType=browser`
              )
              .configureLogging(signalR.LogLevel.Information)
              .withAutomaticReconnect()
              .build();

            this.$store
              .dispatch("setConnection", localConnection)
              .then(conn => {
                this.connection
                  .start()
                  .then(() => {
                    this.connection.on("incomingCall", res => {
                      console.log("sent", res);

                      if (!this.ratingDialog) {
                        this.sound.play();

                        this.$store.dispatch("setObject", res).then(() => {
                          // this.timeout = setTimeout(() => {
                          //   this.dialog = false;
                          //   this.connection.invoke("declineCall", this.object);
                          // }, 10000);
                          this.dialog = true;
                        });
                      }

                      firebase.analytics().logEvent("call_incoming_doctor");
                    });

                    this.connection.on("cancelledCall", res => {
                      if (!this.ratingDialog) {
                        console.log("got cancelled");
                        this.sound.stop();
                        if (this.$store.state.object !== null) {
                        }
                        this.dialog = false;
                        //this.$store.dispatch("setObject", null);
                        this.$router.replace('/home')
                      }
                      firebase.analytics().logEvent("call_cancelled_doctor");
                    });

                    this.connection.on("endedCall", res => {
                      // this.$router.go(-1);
                      //   this.$store.dispatch()
                      if (this.$store.state.object !== null) {
                        this.$router
                          .replace("/home")
                          .then()
                          .catch(err => {});
                        console.log("call ended", res);

                        // this.ratingDialog = true;
                      }
                    });

                    this.connection.on("timedOutCall", () => {
                          if (!this.ratingDialog) {
                      this.sound.stop();
                      this.dialog = false;
                      this.$store.dispatch("setObject", null);
                      firebase.analytics().logEvent("call_timeout_doctor");
                      console.log("timeout");
                          }
                    });
                  })
                  .catch(err => {
                    console.log(err);
                  });
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },

  methods: {
    rate() {
      this.loading = true;
      let rateObject = this.$store.state.object;
      rateObject.doctorsRating = this.rating;

      Axios.post(
        `${process.env.VUE_APP_BASE_URL}/doctor/videoCallRating`,
        rateObject
      )
        .then(res => {
          console.log(res);
          this.loading = false;
          this.$store.dispatch("setRatingDialog", false);
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$store.dispatch("setRatingDialog", false);
        });
    },
    goHome() {
      this.drawer = false;
      this.$router
        .push("/home")
        .then()
        .catch(err => {});
    },
    goProfile(){
      this.drawer = false;
      this.$router
        .push("/profile")
        .then()
        .catch(err => {});
    },
    goInfo() {
      this.drawer = false;
      this.$router
        .push("/info")
        .then()
        .catch(err => {});
    },
    goTerms() {
      this.drawer = false;
      this.$router
        .push("/terms")
        .then()
        .catch(err => {});
    },
    accept() {
      this.rating = null;
      clearTimeout(this.timeout);
      this.sound.stop();
      this.connection.invoke("acceptCall", this.object);
      this.dialog = false;
      this.$router.push(
        `/room/${this.object.videoCallRoom}/${this.object.doctorTwilioToken}`
      );
    },
    decline() {
      clearTimeout(this.timeout);
      this.sound.stop();
      this.connection.invoke("declineCall", this.object);
      this.$store.dispatch("setObject", null);
      this.dialog = false;
    },
    logout() {
      this.drawer = false;
      this.$store
        .dispatch("logout")
        .then(res => {
          this.$router.push("/");
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>


<style lang="scss" scoped>
ul {
  list-style-type: none;
  margin-top: 50px;
}

li {
  cursor: pointer;
  p {
    font-size: 20px;
    &:active {
      font-weight: bold;
    }
  }
}

.box {
  border: 1px solid rgb(240, 240, 240);
  padding: 10px 10px;
}

.actived {
  font-weight: bold;
}

//ready
.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  left: 36px;
  top: 36px;
  cursor: pointer;
}
.bm-burger-bars {
  background-color: #373a47;
}
.line-style {
  position: absolute;
  height: 20%;
  left: 0;
  right: 0;
}
.cross-style {
  position: absolute;
  top: 12px;
  right: 2px;
  cursor: pointer;
}
.bm-cross {
  background: #bdc3c7;
}
.bm-cross-button {
  height: 24px;
  width: 24px;
}
.bm-menu {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Stay on top */
  top: 0;
  left: 0;
  background-color: rgb(63, 63, 65); /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
}

.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}
.bm-item-list {
  color: #b8b7ad;
  margin-left: 10%;
  font-size: 20px;
}
.bm-item-list > * {
  display: flex;
  text-decoration: none;
  padding: 0.7em;
}
.bm-item-list > * > span {
  margin-left: 10px;
  font-weight: 700;
  color: white;
}
</style>
